import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'
import { BASE_URL } from '@yld/yun-utils-host'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  if (BASE_URL.DOMAIN_URL.indexOf('worldex.com.cn') > -1) {
    document.title = '登录-Worldex运价中台'
  } else if (window.location.href.indexOf('huatek.geekyum.com') > -1) {
    document.title = '登录-华泰科技'
  } else if (BASE_URL.DOMAIN_URL.indexOf('topasia.cc') > -1) {
    document.title = '登录-冠亚运价系统'
  } else if (window.location.href.indexOf('ascfre.com') > -1) {
    document.title = '登录'
  } else {
    document.title = getPageTitle(to.meta.title)
  }

  next()
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
})
